var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"server-lcd"},[_c('strong',[_vm._v(_vm._s(_vm._f("abbreviateNumber")(_vm.operations))+" ")]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm._f("pluralize")(_vm.operations,'task', 'tasks'))+" today")])])}
var staticRenderFns = []

export { render, staticRenderFns }